import React from "react";
import EmptyData from "../../../../components/EmptyData";
import { Link } from "react-router-dom";
import toast from "react-hot-toast";
import { useTranslation } from 'react-i18next';

const AssessmentTable = ({ results }) => {
    const { t } = useTranslation();

    const handleActionClick = (result) => {
        if (!result?.resultAssessment?.exam?.show_candidate_result) {
            toast.error(t('result-not-available'));
        }
    };

    const setSessionData = (result) => {
        sessionStorage.setItem('activeExam', result?.resultAssessment?.preferred_exam_title);
        sessionStorage.setItem('isAllowed', 
            result?.resultAssessment?.number_of_attempts - result?.attempt
        ); 
        sessionStorage.setItem('attempt_count', result?.resultAssessment?.number_of_attempts);
        sessionStorage.setItem('activeResult', JSON.stringify(result));
    };

    return (
        <React.Fragment>
            <div className="border border-gray-200 rounded-lg overflow-hidden">
                {!results || results.length === 0 ? (
                    <EmptyData text={t('no-assessments-found')} />
                ) : (
                    <>
                        {/* Mobile View */}
                        <div className="md:hidden w-full p-4 space-y-4">
                            {results.map((result, index) => (
                                <ul className="border bg-white border-gray-300 rounded-lg p-0 divide-y divide-gray-200" key={index}>
                                    <li className="flex justify-between py-3 px-4">
                                        <span className="font-medium text-gray-600">{t('serial-number')}:</span>
                                        <span>{index + 1}</span>
                                    </li>
                                    <li className="flex justify-between py-3 px-4">
                                        <span className="font-medium text-gray-600">{t('assessment-title')}:</span>
                                        <span>{result?.resultAssessment?.preferred_exam_title}</span>
                                    </li>
                                    <li className="flex justify-between py-3 px-4">
                                        <span className="font-medium text-gray-600">{'Started At'}:</span>
                                        <span>{result?.started_at ? new Date(result.started_at).toLocaleString('en-GB') : 'N/A'}</span>
                                    </li>
                                    <li className="flex justify-between py-3 px-4">
                                        <span className="font-medium text-gray-600">{'Completed At'}:</span>
                                        <span>{result?.completed_at ? new Date(result.completed_at).toLocaleString('en-GB') : 'N/A'}</span>
                                    </li>
                                    <li className="flex justify-between py-3 px-4">
                                        <span className="font-medium text-gray-600">{'Attempts Made'}:</span>
                                        <span>{result?.attempt}</span>
                                    </li>
                                    <li className="flex justify-between py-3 px-4">
                                        <span className="font-medium text-gray-600">{'Attempts Allowed'}:</span>
                                        <span>{result?.resultAssessment?.number_of_attempts}</span>
                                    </li>
                                    <li className="flex justify-between py-3 px-4">
                                        <span className="font-medium text-gray-600">{t('action')}:</span>
                                        <div>
                                            {result?.resultAssessment?.exam?.show_candidate_result ? (
                                                <Link
                                                    to={`/candidate/results/${result?.resultAssessment?.id}?userExamId=${result?.user_exam_id}&ended=${result?.termination_status || 'nil'}`}
                                                    className="inline-block text-white bg-primary hover:bg-primary-focus focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-xs px-3 py-2 text-center"
                                                    onClick={() => setSessionData(result)}
                                                >
                                                    {t('view-result')}
                                                </Link>
                                            ) : (
                                                <button
                                                    className="bg-slate-200 text-gray-500 font-medium rounded-lg text-xs px-3 py-2 text-center"
                                                    onClick={() => handleActionClick(result)}
                                                >
                                                    {t('view-result')}
                                                </button>
                                            )}
                                        </div>
                                    </li>
                                </ul>
                            ))}
                        </div>

                        {/* Desktop View */}
                        <div className="hidden md:block overflow-x-auto">
                            <table className="min-w-full text-left text-sm font-light">
                                <thead className="border-b font-medium bg-gray-50">
                                    <tr>
                                        <th className="px-6 py-4">{t('serial-number')}</th>
                                        <th className="px-6 py-4">{t('assessment-title')}</th>
                                        <th className="px-6 py-4">{'Started At'}</th>
                                        <th className="px-6 py-4">{'Completed At'}</th>
                                            <th className="px-6 py-4">{'Attempts Made'}</th>
                                            <th className="px-6 py-4">{'Attempts Allowed'}</th>
                                        <th className="px-6 py-4">{t('action')}</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {results.map((result, index) => (
                                        <tr key={index} className="border-b hover:bg-gray-50 transition-colors">
                                            <td className="px-6 py-4 font-medium">{index + 1}</td>
                                            <td className="px-6 py-4">{result?.resultAssessment?.preferred_exam_title}</td>
                                            <td className="px-6 py-4">
                                                {result?.started_at ? new Date(result.started_at).toLocaleString('en-GB',
                                                    {
                                                        day: "numeric",
                                                        month: "short",
                                                        year: "numeric",
                                                        hour: "numeric",
                                                        minute: "numeric",
                                                        second: "numeric",
                                                        hour12: true,
                                                    }
                                                ) : 'N/A'}
                                            </td>
                                            <td className="px-6 py-4">
                                                {result?.completed_at ? new Date(result.completed_at).toLocaleString('en-GB', {
                                                    day: "numeric",
                                                    month: "short",
                                                    year: "numeric",
                                                    hour: "numeric",
                                                    minute: "numeric",
                                                    second: "numeric",
                                                    hour12: true,
                                                }) : 'N/A'}
                                            </td>
                                            <td className="px-6 py-4">{result?.attempt}</td>
                                            <td className="px-6 py-4">{result?.resultAssessment?.number_of_attempts}</td>
                                            <td className="px-6 py-4">
                                                {result?.resultAssessment?.exam?.show_candidate_result ? (
                                                    <Link
                                                        to={`/candidate/results/${result?.resultAssessment?.id}?userExamId=${result?.user_exam_id}&ended=${result?.termination_status || 'nil'}`}
                                                        className="inline-block text-white bg-primary hover:bg-primary-focus focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-xs px-3 py-2 text-center"
                                                        onClick={() => setSessionData(result)}
                                                    >
                                                        {t('view-result')}
                                                    </Link>
                                                ) : (
                                                    <button
                                                        className="bg-slate-200 text-gray-500 font-medium rounded-lg text-xs px-3 py-2 text-center"
                                                        onClick={() => handleActionClick(result)}
                                                    >
                                                        {t('view-result')}
                                                    </button>
                                                )}
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    </>
                )}
            </div>
        </React.Fragment>
    );
};

export default AssessmentTable;
